import { store } from '../../configuration/setup/store';
import { trace } from '../../configuration/setup/trace';
import { ADD_ROUTE_STATION_EVENT, addStationWaypointHandler } from './events/addStationWaypoint';
import { SET_ROUTING_STOPOVER_POINT, setRoutingStopoverPointHandler } from './events/addStopover';
import { CENTER_ACTIVE_ASSET_EVENT, centerActiveAssetHandler } from './events/centerActiveAsset';
import { MAP_CHANGED_EVENT, mapChangedHandler } from './events/mapChanged';
import { MAP_ROUTE_SELECTED_EVENT, mapRouteSelectedHandler } from './events/mapRouteSelected';
import { SELECT_ASSET_EVENT, selectAssetHandler } from './events/selectAsset';
import { SELECT_GEOFENCES_EVENT, selectGeofencesHandler } from './events/selectGeofences';
import { SELECT_POIS_EVENT, selectPoisHandler } from './events/selectPois';
import { SET_MAP_CONTEXT_EVENT, setMapContextHandler } from './events/setMapContext';
import { SET_ROUTING_END_POINT, setRouteEndWaypointHandler } from './events/setRouteEndWaypoint';
import { SET_ROUTING_START_POINT, setRouteStartWaypointHandler } from './events/setRouteStartWaypoint';
import { SET_WIDGET_ID_EVENT, setWidgetIdHandler } from './events/setWidgetId';
import { VISIBLE_WIDGETS_EVENT, visibleWidgetsHandler } from './events/visibleWidgets';

const EVENT_PREFIX = 'EVENT';

// Re-exported for backwards compatibility with existing imports of sendMessage/sendWidgetMessage
// from this module. New code that only needs messaging (not processWidgetAction) should import
// directly from './widgetMessaging' to avoid pulling in the full event-handler graph (and `store`).
export { sendMessage, sendWidgetMessage } from './widgetMessaging';

export const processWidgetAction = (event: MessageEvent) => {
    const actionType = event.data.type;
    if (!actionType?.startsWith(EVENT_PREFIX)) {
        return;
    }

    const payload = event.data.payload;

    try {
        switch (actionType) {
            case SELECT_ASSET_EVENT:
                selectAssetHandler(payload);
                break;
            case SET_WIDGET_ID_EVENT:
                setWidgetIdHandler(payload);
                break;
            case VISIBLE_WIDGETS_EVENT:
                visibleWidgetsHandler(payload);
                break;
            case CENTER_ACTIVE_ASSET_EVENT:
                centerActiveAssetHandler(payload);
                break;
            case MAP_CHANGED_EVENT:
                mapChangedHandler(payload);
                break;
            case SET_MAP_CONTEXT_EVENT:
                setMapContextHandler(payload);
                break;
            case SELECT_POIS_EVENT:
                selectPoisHandler(payload);
                break;
            case SELECT_GEOFENCES_EVENT:
                selectGeofencesHandler(payload);
                break;
            case ADD_ROUTE_STATION_EVENT:
                addStationWaypointHandler(payload);
                break;
            case SET_ROUTING_STOPOVER_POINT:
                setRoutingStopoverPointHandler(event.data, payload);
                break;
            case SET_ROUTING_START_POINT:
                setRouteStartWaypointHandler(event, payload);
                break;
            case SET_ROUTING_END_POINT:
                setRouteEndWaypointHandler(event, payload);
                break;
            case MAP_ROUTE_SELECTED_EVENT:
                mapRouteSelectedHandler(payload, store.dispatch, store.getState);
                break;
            default:
                trace.warn(`Unknown widget action: ${actionType}`);
        }
    } catch (error) {
        trace.error(`Failed to process widget message: ${actionType}`, error);
    }
};
